module.exports = __webpack_public_path__ + "img/ic_qrcode_tiktok.952f2da.webp";